module.exports = __webpack_public_path__ + "img/image (156).17878647.jpg";